import { setCookie, getCookie } from '../utilities/CookieUtils'

const cookieName = 'leshuttle.sitealerts.dismissed'

export function setupSiteAlerts () {
  const siteAlert = document.querySelector('[data-site-alert]')
  const alertId = siteAlert?.dataset?.siteAlert

  if (!siteAlert || !alertId) {
    return
  }

  const cookieValue = getCookie(cookieName)

  if (!cookieValue || !alertSeen(cookieValue, alertId)) {
    showModal(siteAlert)
    const dismissButton = siteAlert.querySelector('button')

    if (dismissButton) {
      dismissButton.addEventListener('click', () => {
        dismissModal(siteAlert, alertId)
      })
    }
  }
}

function showModal (modal) {
  modal.classList.remove('hide')
}

function dismissModal (modal, alertId) {
  addSeenAlert(alertId)
  modal.classList.add('hide')
}

function alertSeen (cookieValue, alertId) {
  if (!cookieValue) {
    return false
  }
  return getSeenAlerts(cookieValue)?.find(x => x === alertId)
}

function getSeenAlerts (cookieValue = null) {
  const value = cookieValue || getCookie(cookieName)

  if (!value) {
    return []
  }

  return JSON.parse(value)
}

function addSeenAlert (alertId) {
  const alerts = getSeenAlerts()
  alerts.push(alertId)
  setCookie(cookieName, JSON.stringify(alerts))
}
